import { render } from "./MainFeatures.vue?vue&type=template&id=13f97305"
import script from "./MainFeatures.vue?vue&type=script&lang=js"
export * from "./MainFeatures.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sr.vlas/vendor/v-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__